import { StandardLayout, Flex } from '@sequencehq/core-components'
import { BillingScheduleHeader } from 'modules/Cube/view/layouts/billingSchedule/BillingScheduleHeader/BillingScheduleHeader'
import { PricingWidget } from 'Cube/view/common/widgets/Pricing/PhasesWidget'
import { AdditionalInformationWidget } from 'modules/Cube/view/layouts/billingSchedule/widgets/AdditionalInformation/AdditionalInformationWidget'
import { CustomerWidget } from 'modules/Cube/view/layouts/billingSchedule/widgets/Customer/CustomerWidget'
import { InvoiceSettingsWidget } from 'modules/Cube/view/layouts/billingSchedule/widgets/InvoiceSettings/InvoiceSettingsWidget'
import { AmendmentLockBanner } from 'modules/Cube/view/layouts/billingSchedule/AmendmentLockBanner'
import { BillingScheduleInspector } from './BillingScheduleInspector'
import { useCubeShortcuts } from './hooks/useCubeShortcuts'

export const BillingScheduleLayout = () => {
  useCubeShortcuts()

  return (
    <StandardLayout
      data-testid="schedule.layout"
      header={<BillingScheduleHeader />}
      content={
        <StandardLayout.Content scrollable>
          <Flex flexDir="column" gap="20px" width="1104px" mx="auto">
            <AmendmentLockBanner />
            <CustomerWidget />
            <PricingWidget wideLayout />
            <InvoiceSettingsWidget />
            <AdditionalInformationWidget />
          </Flex>
        </StandardLayout.Content>
      }
      inspector={<BillingScheduleInspector />}
    />
  )
}
